import { defineComponent } from "vue";

// Components
import MainBarMenuV2 from "@/components/layouts/MainBarMenuV2.vue";
import HeadingUser from "@/components/user/HeadingUser.vue";
import Typography from "@/components/general/Typography";

// services
import processSevices from "@/services/legal/service.js";


export default defineComponent({
  components: {
    MainBarMenuV2,
    HeadingUser,
    Typography,
  },
  data() {
    return {
      urlPdf: null,
    };
  },
  methods: {
    initData() {
      processSevices.getHelpProcess().then((response)=>{
        this.urlPdf  = window.URL.createObjectURL(new Blob([response], { type:"application/pdf" })) + '#toolbar=0'; 
      })
    },

  },
  mounted() {
    this.initData();
  },
});
